// Всплывающие уведомления (ошибки, подтверждения).
import { useSyncExternalStore } from 'react'
import { errorMessage } from './api.ts'

export interface ToastItem {
  id: number
  message: string
  tone: 'error' | 'success' | 'info'
  /** Заголовок над текстом (например, «OMA-12 готова»). */
  title?: string
  /** Клик по уведомлению открывает задачу. */
  taskId?: number
}

let items: ToastItem[] = []
let seq = 0
const listeners = new Set<() => void>()

function emit(): void {
  for (const l of listeners) l()
}

export function dismissToast(id: number): void {
  items = items.filter((t) => t.id !== id)
  emit()
}

export function toast(message: string, tone: ToastItem['tone'] = 'info', opts: { title?: string; taskId?: number; ms?: number } = {}): void {
  const id = ++seq
  items = [...items.slice(-4), { id, message, tone, title: opts.title, taskId: opts.taskId }]
  emit()
  window.setTimeout(() => dismissToast(id), opts.ms ?? (tone === 'error' ? 7000 : 4000))
}

export function toastError(e: unknown, prefix?: string): void {
  const msg = errorMessage(e)
  toast(prefix ? `${prefix}: ${msg}` : msg, 'error')
}

export function useToasts(): ToastItem[] {
  return useSyncExternalStore(
    (fn) => {
      listeners.add(fn)
      return () => {
        listeners.delete(fn)
      }
    },
    () => items,
  )
}
